
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { v_EmployeeSearchBus } from '../models/v_EmployeeSearchBus';
import { KPIParameter } from '../models/KPIParameter';

@Injectable()
export class EOSService extends BaseService {

  constructor(_http: HttpClient) {
    super(_http);
    this.baseUrl = this.rootUrl + "EOS/";
  }

     getUserScorecards(id: string): Observable<any> {
        let headers = this.getHeaders();
            let url_call: string = this.baseUrl + "GetUserScorecards/" + id;
        return this._http.get(url_call, { headers: headers });
      }
    getUserKPIs(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetUserKPIs/" + id;
        return this._http.get(url_call, { headers: headers });
    }
    getUserKPIParameterHistory(id: string, start: any, end: any): Observable<any> {
        let options = this.getOptionsU(id, "start", JSON.stringify(start), "end", JSON.stringify(end));
        let url_call: string = this.baseUrl + "GetUserKPIParameterHistory";
        return this._http.get(url_call, options); // { headers: headers }); //options ); //, { headers: headers });
    }

    getKPIs(param: KPIParameter): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "KPIParameter", s_param);
        let url_call: string = this.baseUrl + "GetKPIs";
        return this._http.get(url_call, options);
    }
    getAllUserKPIs(param: KPIParameter): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "KPIParameter", s_param);
        let url_call: string = this.baseUrl + "GetAllUserKPIs";
        return this._http.get(url_call, options);
    }
}
